import {useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {useLingui} from '@lingui/react'
import {msg, Trans} from '@lingui/macro'
import {
    Alert
    , Box
    , Button
    , MenuItem, styled, TextField, useTheme
} from '@mui/material/'
import {
    GridRowModes
    , DataGrid
    , GridToolbarContainer
    , GridActionsCellItem
    , GridRowEditStopReasons
    , gridClasses
} from '@mui/x-data-grid'
// import AddIcon from '@mui/icons-material/Add'
// import AddBoxIcon from '@mui/icons-material/AddBox'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import SaveIcon from '@mui/icons-material/Save'
import CancelIcon from '@mui/icons-material/Cancel'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import OrganizationIcon from '../OrganizationIcon'
import {randStr} from '../../utils'
import SvgCustomIcon from "../icons/SvgCustomIcon";
import {Typography} from "@mui/material";
import {StripedDataGrid} from "./StripedDataGrid";
import {Check} from "@mui/icons-material";

// canChange: false
// column: "report_date"
// isRequired: true
// label: "Report date"
// margin: "dense"
// options: []
// permissions: [1, 2, 3]
// type: "date"
// unit: ""
// value: {}

const paginationModel = {page: 0, pageSize: 25}


export default function ConfTable({section, sections, sectionRows, modifyField, error, message, handleResetMessage}) {
    const location = useLocation()
    const init = location.state?.init || {}
    const {configuration, organizations} = init
    const theme = useTheme()
    const {_} = useLingui()
    const [rows, setRows] = useState([])
    const [rowModesModel, setRowModesModel] = useState({})

    useEffect(() => {
        if (sectionRows.length) setRows(sectionRows)
    }, [sectionRows])

    useEffect(() => {
        console.log('ROWS', rows)
    }, [rows])

    const handleRowEditStop = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true
        }
    }

    // const CustomCellEditor = props => {
    //   const { id, field, value, row, api } = props

    //   const handleChange = event => {
    //     const newTypeValue = event.target.value
    //     let value
    //     if (newTypeValue === 'date') value = _(msg`date of fill`)
    //     if (newTypeValue === 'datetime') value = _(msg`date & time of fill`)
    //     if (newTypeValue === 'text') value = _(msg`empty field`)
    //     if (newTypeValue === 'select') value = _(msg`Unknown`)

    //     // Update the row data in the DataGrid
    //     // api.setEditCellValue({ id, field, value: newValue })

    //     // Recalculate the total
    //     const updatedRow = { ...row, [field]: newTypeValue, value }

    //     // Update the row in the DataGrid
    //     api.updateRows([updatedRow])
    //   }

    //   return (
    //     <TextField
    //       select
    //       value={value}
    //       onChange={handleChange}
    //       fullWidth
    //       autoFocus
    //     >
    //       {['text', 'select', 'date', 'datetime'].map(opt => (
    //         <MenuItem key={opt} value={opt}>
    //           {opt}
    //         </MenuItem>
    //       ))}
    //     </TextField>
    //   )
    // }

    const handleDeleteClick = id => () => {
        handleResetMessage()
        setRows(rows.filter(row => row.id !== id))
        const row = rows.find(row => row.id === id)
        modifyField(row.label, {action: 'delete', section: row.section})
    }

    const handleAddClick = () => {
        handleResetMessage()
        const id = randStr()
        setRows(oldConfig => [
            {
                id
                , section
                , permissions: []
                , label: ''
                , isRequired: false
                , type: 'text'
                , options: []
                , unit: ''
                , value: ''
                , canChange: true
                , isNew: true
            }
            , ...oldConfig
        ])
        setRowModesModel(oldModel => ({
            [id]: {mode: GridRowModes.Edit, fieldToFocus: 'permissions'}
            , ...oldModel
        }))
    }

    const handleEditClick = id => () => {
        handleResetMessage()
        setRowModesModel({...rowModesModel, [id]: {mode: GridRowModes.Edit}})
    }

    const handleSaveClick = id => () => {
        setRowModesModel({...rowModesModel, [id]: {mode: GridRowModes.View}})
    }

    const handleCancelClick = id => () => {
        setRowModesModel({
            ...rowModesModel
            , [id]: {mode: GridRowModes.View, ignoreModifications: true}
        })

        const editedRow = rows.find(row => row.id === id)
        if (editedRow.isNew) {
            setRows(rows.filter(row => row.id !== id))
        }
    }

    const processRowUpdate = (newRow, oldRow) => {
        setRows(rows.map(row => (row.id === newRow.id ? newRow : row)))
        const label = newRow.isNew ? newRow.label : oldRow.label
        modifyField(label, newRow)
        return newRow
    }

    const handleRowModesModelChange = newRowModesModel => {
        setRowModesModel(newRowModesModel)
    }

    const columns = [
        {field: 'id', headerName: ''} // hidden
        , {field: 'section', headerName: _(msg`Section`)} // hidden
        , {field: 'column', headerName: _(msg`Column`)} // hidden
        , {field: 'isNew', headerName: _(msg`New?`), type: 'boolean'} // hidden
        , {
            field: 'permissions'
            , headerName: _(msg`Organizations`)
            , headerClassName: 'overload-header'
            , flex: 1.1 // , minWidth: 110
            , editable: (_, row) => row.isNew
            , valueGetter: value => value?.map(v => organizations.find(o => o.value === v)?.label)
            , valueSetter: (value, row) => {
                if (value) {
                    let matches = []

                    if (Array.isArray(value)) matches = value
                    else {
                        const regex = /\b(police|healthcare|insurance)\b/gi
                        let match

                        while ((match = regex.exec(value)) !== null) {
                            matches = [...matches, match[0]]
                        }
                    }

                    const newValue = matches.map(v => organizations.find(o => o.label === v).value)
                    return {...row, permissions: newValue}
                }
                return {}
            }
            , renderCell: params => {
                if (params.value?.length) {
                    console.log('params.value ... ', params.value)
                    return (
                        <Box sx={{
                            justifyContent: 'center',
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'row',
                            gap: 1,
                            height: '100%'
                        }}>
                            {params.value.map((v, k) => {
                                    console.log('v ... ', v)
                                    const iconName = v === 'Police' ? 'police' : v === 'Healthcare' ? 'healthCrossOutline' : 'insurance'
                                    return (
                                        <SvgCustomIcon color={theme.palette.newColors.gray} name={iconName}/>
                                    )
                                }
                            )}
                        </Box>
                    )
                }
            }
        }
        , {
            field: 'label'
            , headerName: _(msg`Label`)
            , headerClassName: 'overload-header'
            , flex: 2 // , minWidth: 200
            , editable: (_, row) => row.canChange || row.isNew
            // , renderEditCell  : ({ value }) => {
            // if (value === '') {
            //   return <TextField sx={{ border: null, width: '100%', '&:focus-visible': { border: 0 }, '&:active': { border: 0 } }} placeholder='Type a label...' />
            // }
            // return value
            // }
        }
        , {
            field: 'isRequired'
            , headerName: _(msg`Required?`)
            , headerClassName: 'overload-header'
            , type: 'boolean'
            , flex: 1 // , minWidth: 100
            , editable: (_, row) => row.canChange || row.isNew
            ,  renderCell: (params) => {
        const isVerified = params.value
        const color = theme.palette.mode === 'dark'
            ? (isVerified ? '#4caf50' : '#f44336')
            : (isVerified ? '#2e7d32' : '#d32f2f')

        return isVerified
            ? <Check sx={{ color }} />
            : <CancelIcon sx={{ color }} />
    }
        }
        , {
            field: 'type'
            , headerName: _(msg`Type`)
            , headerClassName: 'overload-header'
            , type: 'singleSelect'
            , valueOptions: ['text', 'select', 'date', 'datetime']
            , flex: 1 // , minWidth: 100
            , editable: (_, row) => row.isNew
            // , renderEditCell  : params => <CustomCellEditor { ...params } />
        }
        , {
            field: 'options'
            , headerName: _(msg`Options`)
            , headerClassName: 'overload-header'
            , flex: 4 // , minWidth: 400
            , editable: (_, row) => row.type === 'select' && (row.canChange || row.isNew)
            , valueGetter: (value, row) => row.type === 'select' ? value.map(e => e.label) : []
            , valueSetter: (value, row) => { // ctx additional parameter
                if (row.type === 'select') {
                    let newOptions
                    if (row.isNew) {
                        const input = value ? Array.isArray(value) ? value : value.split(',') : ['Unknown']
                        newOptions = input.map((v, i) => ({label: v, value: i}))
                    } else {
                        const options = configuration[row.section]?.elements
                            .find(elem => elem.column === row.column)?.options
                        console.log(options)
                        const input = Array.isArray(value) ? value : value?.split(',')
                        newOptions = input.map((v, i) => ({
                            label: v,
                            value: options.find(o => o.label === v)?.value || i
                        }))
                        // newOptions = input.map((v, i) => ({ label: v, value: i }))
                    }
                    return {...row, options: newOptions}
                }
                return {...row, options: []}
            }
        }
        , {
            field: 'unit'
            , headerName: _(msg`Unit`)
            , headerClassName: 'overload-header'
            , flex: 0.75 // , minWidth        : 75
            , editable: (_, row) => row.canChange || row.isNew
        }
        , {
            field: 'value'
            , headerName: _(msg`Default`)
            , headerClassName: 'overload-header'
            , flex: 1 // , minWidth        : 100
            , editable: (_, row) => row.isNew
            , valueGetter: (value, row) => {
                if (row.type === 'date') return _(msg`date of fill`)
                if (row.type === 'datetime') return _(msg`date & time of fill`)
                if (row.type === 'text') return _(msg`empty field`)
                if (row.type === 'select') return _(msg`Unknown`)
                return value
            }
        }
        , {
            field: 'actions'
            , type: 'actions'
            , headerName: _(msg`Actions`)
            , headerClassName: 'overload-header'
            , cellClassName: 'actions'
            , flex: 1 // , minWidth        : 100
            , getActions: obj => {
                const {id, row: {canChange}} = obj
                const isInEditMode = () => {
                    return rowModesModel[id]?.mode === GridRowModes.Edit
                }

                if (isInEditMode()) {
                    return [
                        <GridActionsCellItem
                            icon={<SvgCustomIcon name={'save'}/>}
                            label="Save"
                            sx={{
                                color: 'primary.main'
                            }}
                            onClick={handleSaveClick(id)}
                        />
                        , <GridActionsCellItem
                            icon={<SvgCustomIcon name={'cancel'}/>}
                            label="Cancel"
                            className="textPrimary"
                            onClick={handleCancelClick(id)}
                            color="inherit"
                        />
                    ]
                }

                return [
                    <GridActionsCellItem
                        icon={<SvgCustomIcon color={theme.palette.newColors.gray} name={'edit'}/>}
                        label="Edit"
                        className="textPrimary"
                        onClick={handleEditClick(id)}
                        color="inherit"
                        disabled={!canChange}
                    />
                    , <GridActionsCellItem
                        icon={<SvgCustomIcon color={theme.palette.newColors.gray} name={'delete'}/>}
                        label="Delete"
                        onClick={handleDeleteClick(id)}
                        color="inherit"
                        disabled={!canChange}
                    />
                ]
            }
        }
    ]

    const legendWithIcon = [
        { key: 'police', label: _(msg`Police`) },
        { key: 'healthcare', label: _(msg`Healthcare`) },
        { key: 'insurance', label: _(msg`Insurance`) }
    ]

    console.log('section ---> ', section)
    const sectionLabels = {
        crash: msg`Crash`,
        road: msg`Road`,
        units: msg`Units`,
        people: msg`People`
    }

    return (
        <Box
            width='100%'
            sx={{
                '& .overload-header': {
                    backgroundColor: theme.palette.primary.main
                    , color: theme.palette.primary.contrastText
                }
            }}
        >
            <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', p: 1}}>
                <Box sx={{display: 'flex', flexDirection: 'row', gap: 12, alignItems: 'center'}}>
                    <Typography
                        sx={{
                            color: theme.palette.mode === 'light'
                                ? theme.palette.newColors.gray
                                : theme.palette.newColors.lightGray,
                            fontWeight: 'bold'
                        }}
                    >
                        { _(sectionLabels[section] || msg`${section}`).toUpperCase() }
                    </Typography>
                    <Button
                        startIcon={<AddCircleIcon/>}
                        variant="contained"
                        onClick={handleAddClick}
                        sx={{
                            background: theme.palette.newColors.pinkGradient,
                            color: 'white',
                            '&:hover': {
                                background: theme.palette.newColors.pinkGradient,
                                opacity: 0.9,
                            },
                        }}
                    >
                        <Trans>Add item</Trans>
                    </Button>
                </Box>
                {section === 'crash' &&
                    <Box sx={{display: 'flex', flexDirection: 'row', gap: 4}}>
                        {legendWithIcon.map((v, k) => {
                            const iconName =
                                v.key === 'police'
                                    ? 'police'
                                    : v.key === 'healthcare'
                                        ? 'healthCrossOutline'
                                        : 'insurance'

                            const iconColor =
                                theme.palette.mode === 'light'
                                    ? theme.palette.newColors.gray
                                    : theme.palette.newColors.lightgray

                            return (
                                <Box key={k} sx={{display: 'flex', flexDirection: 'row', gap: 2}}>
                                    <SvgCustomIcon color={iconColor} name={iconName}/>
                                    <Typography sx={{color: iconColor}}>{v.label}</Typography>
                                </Box>
                            )
                        })}
                    </Box>
                }
            </Box>
            <StripedDataGrid
                showColumnVerticalBorder
                showCellVerticalBorder
                rows={rows}
                columns={columns}
                editMode="row"
                rowModesModel={rowModesModel}
                onRowModesModelChange={() => handleRowModesModelChange('crash')}
                onRowEditStop={handleRowEditStop}
                processRowUpdate={processRowUpdate}
                initialState={{
                    pagination: {paginationModel}
                    , columns: {
                        columnVisibilityModel: {
                            id: false
                            , section: false
                            , column: false
                            , isNew: false
                            , value: false
                        }
                    }
                }}
                experimentalFeatures={{newEditingApi: true}} // Enable the new editing API
                hideFooter={rows.length <= paginationModel.pageSize}
                pageSizeOptions={[paginationModel.pageSize]}
                getRowClassName={params => {
                    return params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                }}

            />
            {error && <Alert sx={{mt: 2}} severity="error">
                <Trans>There was an error: {error}.</Trans>
            </Alert>}
            {message && <Alert sx={{mt: 2}} severity='success'>
                {message}
            </Alert>}
        </Box>
    )
}
